/**
 * Created by fuzhengsong on 2018/3/16.
 */
import * as types from './types';
import actions from './actions';
import {
  extend,
  each,
  set
} from 'lodash';

const state = {
  settingList: {
    state: '',   // loading, loadend, loaderr
    list: []
  },
  settingListItem: {
    visible: false,
    elements: [],
    form: {}
  },
};

const getters = {
  getAdminSystemSettingsList: (state) => state.settingList,
  getAdminSystemSettingsListItem: (state) => state.settingListItem,
};

const mutations = {
  [types.ADMIN_SETTING_LIST_CHANGE]({settingList}, result){
    extend(settingList, result)
  },
  [types.ADMIN_SETTING_ITEM_CHANGE]({settingListItem}, result) {
    let extendResult = {};
    each(result, function (value, key) {
      if (key.indexOf('.') === -1) {
        extendResult[key] = value;
      } else {
        set(extendResult, key, value);
      }
    });
    extend(settingListItem, extendResult);
  },
};


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Admin/modules/Settings/index.js